import { type MiddlewareFunction } from '@segment/analytics-next'

import { getBotInfo } from './getBotInfo'
import { getIsInternalUser } from './getIsInternalUser'
import { logger } from 'utils/logger'

export const segmentMiddleware: MiddlewareFunction = ({ payload, next }) => {
  try {
    const isInternalUser = getIsInternalUser()
    const { isBot } = getBotInfo()

    // Suppress all Segment events for users who are internal users or bots.
    // Not calling `next(payload)` causes the Segment currently being processed
    // by this middleware function not to be fired/sent to Segment.
    if (isInternalUser || isBot) {
      logger.log(
        'Suppressing Segment event. Payload would have been: ',
        payload,
      )
      return undefined
    }

    // For legitimate users, attach a messageId property to checkout started
    // events in order to de-dupe
    if (
      payload?.obj?.event === 'Checkout Started' &&
      payload?.obj?.properties?.order_id
    ) {
      payload.obj.messageId = `checkout-started-${payload.obj.properties.order_id}`
    }
    next(payload)
  } catch (err) {
    logger.log('Error in segmentMiddleware: ', err)
  }
}
